import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AlertsService } from '../../../../services/alerts/alerts.service';
import { InputComponent } from '../../../core/controls/input.component';
import { SelectComponent } from '../../../core/controls/select.component';

@Component({
  selector: 'app-amount-option',
  imports: [SelectComponent, InputComponent],
  template: `
    <div class="tw-col-span-2 tw-flex">
      <span class="label tw-grow tw-font-bold tw-pt-2">{{ label }}</span>

      <app-select
        class="tw-w-[250px]"
        [options]="alerts.amountOps"
        optionLabel="description"
        [optionValue]="null"
        [control]="listControl"
        label="Condition"
        [filter]="false"
        [virtualScroll]="false"
        [showClear]="false"
      />

      <app-input type="Currency" [control]="control" label="Amount"></app-input>
    </div>
  `,
  styles: ``,
})
export class AmountOptionComponent implements OnInit {
  alerts = inject(AlertsService);

  @Input()
  listControl: FormControl<any>;

  @Input()
  control: FormControl<number>;

  @Input()
  label: string;

  async ngOnInit() {
    this.listControl.addValidators([Validators.required]);
    if (this.listControl.value == null) {
      this.listControl.setValue(
        this.alerts.find(this.alerts.amountOps, 'IncreasedBy'),
      );
    }
    this.listControl.updateValueAndValidity({ emitEvent: false });

    this.control.addValidators([Validators.required]);
    this.control.updateValueAndValidity({ emitEvent: false });
  }
}
